var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "remove_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#remove_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12.75a.726.726 0 01-.534-.216A.726.726 0 015.5 12c0-.213.072-.391.216-.535a.726.726 0 01.534-.215h11.5c.212 0 .39.072.534.216A.726.726 0 0118.5 12c0 .213-.072.391-.216.535a.726.726 0 01-.534.215H6.25z",
    fill: "#fff"
  }))));
}
export default SvgRemove;